export const formatDateToYYYYMMDD = (date: Date) => {
    if (!date) throw Error("date cannot be null/undefined");

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Add 1 because months are 0-based
    const day = String(date.getDate()).padStart(2, '0'); // Ensure 2 digits
    return `${year}${month}${day}`;
};

export { };

//Adding extension/prototype function
declare global {
    interface Date {
        display(): string,
    }
}

Date.prototype.display = function (): string {
    return this.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
    });
}
